<script setup>
import { ref } from 'vue'
import RatingCard from './RatingCard.vue'

const testimonials = ref([
  {
    content:
      "ComplianceClerk streamlined our Corporate Transparency filings, saving us time and eliminating errors. It's a must-have for business owners needing to focus on growth without worrying about compliance headaches.",
    author: 'Joseph Ritzpah',
    position: 'Owner, Ritzpah Plumbing'
  }
  // Add more testimonials as needed
])
</script>

<template>
  <div class="container content-space-1 content-space-lg-1 pb-3">
    <div class="w-md-75 w-lg-50 text-center mx-md-auto mb-4 mb-md-5">
      <h2 class="mb-3 display-6">Our Customers Love Us</h2>
      <RatingCard />
    </div>
    <div class="text-center mb-5">
      <img
        alt="Square Headshot"
        class="avatar avatar-xl avatar-circle"
        height="374"
        src="https://media.complianceclerk.com/media/images/Screenshot_2023-11-09_at_3.20.51PM.width-400.png"
        width="380"
      />
    </div>

    <figure
      class="w-md-75 text-center mx-md-auto"
      v-for="(testimonial, index) in testimonials"
      :key="index"
    >
      <blockquote class="blockquote">"{{ testimonial.content }}"</blockquote>
      <figcaption class="blockquote-footer text-center">
        {{ testimonial.author }}
        <span class="blockquote-footer-source">{{ testimonial.position }}</span>
      </figcaption>
    </figure>
  </div>
</template>
